<template>
  <b-form-group :id="`input-group-${id}`">
    <label :for="`input-${id}`">{{ label }}:</label>
    <b-form-input
      size="sm"
      :id="`input-${id}`"
      v-model="inputValue"
      :placeholder="placeholder"
      :state="error ? false : null"
    ></b-form-input>
    <b-form-invalid-feedback v-if="error">
      {{ error }}
    </b-form-invalid-feedback>
  </b-form-group>
</template>

<script>
export default {
  name: 'InputField',
  props: {
    id: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    value: {
      type: [String, Number],
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    error: {
      type: String,
      default: '',
    },
  },
  computed: {
    inputValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script> 
